import { Injectable } from '@angular/core';
import { PATH_LOGIN } from 'src/app/login/login.global';
import { AuthBaseEffects } from 'src/app/calvin-emr-shared/state/auth/auth-base.effects';
import { PATH_PATIENTS } from 'src/app/patients/patients.global';

@Injectable()
export class AuthEffects extends AuthBaseEffects {
  constructor() {
    super(PATH_PATIENTS, PATH_LOGIN);
  }
}
